import { createContext } from 'react';

export const HubContext = createContext({
	initialized: false,
	langIndex: 0,
	onInitBlock: () => null,
	onReverseBlock: () => null,
	onNext: () => null,
});
